import { createRoot } from "react-dom/client";
import "@fontsource/dm-sans/400.css";
import "@fontsource/dm-sans/500.css";
import "@fontsource/dm-sans/700.css";
import App from "./App.tsx";
import "./index.css";
import { captureUtmsOnLoad } from "./lib/utmAttribution";

captureUtmsOnLoad();

createRoot(document.getElementById("root")!).render(<App />);
